import { clientCookie } from './clientCookie';

export const PENDING_PIX_COOKIE_NAME = 'gn_pix_pending_gamification';
// Cookie de longa duração: um pix pago pode ser reconciliado quando o
// profissional voltar à loja, mesmo dias depois. A limpeza de um pix não pago
// acontece no reconcile via ENTRY_TTL_HOURS, não pela expiração do cookie.
export const PENDING_PIX_COOKIE_TTL_DAYS = 30;
export const ENTRY_TTL_HOURS = 24;

export interface IPendingPixGamification {
  transactionId: string;
  bundleNameId: string;
  profileId: string | number;
  generatedAt: string;
  hadDiscount: boolean;
}

export function isPendingPixStale(entry: IPendingPixGamification): boolean {
  const generatedAt = new Date(entry.generatedAt).getTime();
  if (Number.isNaN(generatedAt)) return true;
  const ageMs = Date.now() - generatedAt;
  return ageMs > ENTRY_TTL_HOURS * 60 * 60 * 1000;
}

export function parsePendingPixGamification(
  raw: string | null | undefined
): IPendingPixGamification | null {
  if (!raw) return null;
  try {
    const parsed = JSON.parse(decodeURIComponent(raw));
    if (
      typeof parsed?.transactionId !== 'string' ||
      typeof parsed?.generatedAt !== 'string'
    ) {
      return null;
    }
    // Não descartamos por idade aqui: o reconcile precisa conseguir ler um pix
    // antigo para creditar a gamificação caso ele tenha sido pago. A idade só
    // decide o descarte de um pix NÃO pago (ver reconcile) e o lock do desconto.
    return {
      ...parsed,
      hadDiscount: parsed.hadDiscount === true,
    } as IPendingPixGamification;
  } catch {
    return null;
  }
}

export function serializePendingPixGamification(
  data: IPendingPixGamification
): string {
  return encodeURIComponent(JSON.stringify(data));
}

export function readPendingPixGamification(): IPendingPixGamification | null {
  return parsePendingPixGamification(clientCookie.get(PENDING_PIX_COOKIE_NAME));
}

export function savePendingPixGamification(
  data: IPendingPixGamification
): void {
  clientCookie.set(
    PENDING_PIX_COOKIE_NAME,
    serializePendingPixGamification(data),
    PENDING_PIX_COOKIE_TTL_DAYS
  );
}

export function clearPendingPixGamification(): void {
  clientCookie.erase(PENDING_PIX_COOKIE_NAME);
}

export function hasLockedPixGamification(): boolean {
  const pending = readPendingPixGamification();
  if (!pending) return false;
  // Após 24h sem pagamento o desconto é destravado (o reconcile limpa o cookie).
  if (isPendingPixStale(pending)) return false;
  return pending.hadDiscount === true;
}
